import { useMemo } from "react";
import { TextInput } from "react-admin";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useWatch } from "react-hook-form";
import { resolveRazaEventVenueAddress } from "@/utils/raza-event-venue-address";
import { razaEventVenueAddressFieldCopy } from "./raza-event-venue-address-field";

/**
 * Address / venue field for raza events.
 * Bound to persisted `address` (manual override). When a linked hall has a venue,
 * that venue is shown as the effective location and the input is labeled as override-only.
 */
export function RazaEventVenueAddressField() {
  const hallBookings = useWatch({ name: "hallBookings" });
  const address = useWatch({ name: "address" });

  const resolved = useMemo(
    () =>
      resolveRazaEventVenueAddress({
        storedAddress: address,
        hallBookings,
      }),
    [address, hallBookings]
  );

  const copy = useMemo(
    () => razaEventVenueAddressFieldCopy(resolved.source, resolved.value),
    [resolved.source, resolved.value]
  );

  return (
    <Box>
      {copy.hallVenueLine ? (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {copy.hallVenueLine}
        </Typography>
      ) : null}
      <TextInput
        source="address"
        label={copy.label}
        fullWidth
        multiline
        minRows={2}
        helperText={copy.helperText}
      />
    </Box>
  );
}
